/* eslint prefer-template:0 */

export default function instrument(window, requirejs, queryUtil, editorModel) {
  editorModel = editorModel || {}

  const editorVersion = editorModel.editorVersion
  const base = (window.serviceTopology.biServerUrl || 'http://frog.wix.com').replace(/\/$/, '')
  const suppressbi = queryUtil.isParameterTrue('suppressbi')
  const isDebug = queryUtil.getParameterByName('debug')

  const storage = (function () {
    try {
      const s = window.sessionStorage
      const test = 'ep' + Date.now()
      s.setItem(test, test)
      if (s.getItem(test) === test) {
        s.removeItem(test)
        return s
      }
    } catch (e) {
      const data = {}
      return {
        setItem(k, v) {
          data[k] = v
        },
        getItem(k) {
          return data[k]
        },
        removeItem(k) {
          delete data[k]
        }
      }
    }
  }())
  if (window.isPrefetchMode) {
    storage.setItem('afterEditorPrefetch', 'true')
  } else {
    window.afterEditorPrefetch = !!storage.getItem('afterEditorPrefetch')
    storage.removeItem('afterEditorPrefetch')
  }

  const performance = window.performance
  if (performance && performance.mark) {
    if (performance.setResourceTimingBufferSize) {
      if ('onresourcetimingbufferfull' in performance) {
        performance.onresourcetimingbufferfull = (function () {
          let maxSize = 150
          return function () {
            maxSize *= 2
            performance.setResourceTimingBufferSize(maxSize)
          }
        }())
      } else {
        performance.setResourceTimingBufferSize(isDebug ? 1000 : 300)
      }
    }
    performance.mark('main-r loaded')
  }

  function getCookie(name) {
    const re = new RegExp('(?:^|\\W)' + name + '\s*=([^;]*)')
    const m = window.document.cookie.match(re)
    return m ? m[1].trim() : m
  }

  const permissionInfo = editorModel.permissionsInfo || {}
  const implicitParams = (function () {
    const implicitFields = {
      ownerId() {
        return permissionInfo.ownerId || ''
      },
      roles() {
        const loggedInUserRoles = (permissionInfo.loggedInUserRoles || []).map(loggedInUserRole =>
                     loggedInUserRole.role
                  ).join()
        this.roles = function () {
          return loggedInUserRoles
        }
        return this.roles()
      },
      esi() {
        return editorModel.editorSessionId || ''
      },
      did() {
        return window.siteId || ''
      },
      msid() {
        return editorModel.metaSiteId || ''
      },
      ts(now) {
        return now - (window.mainLoaded || 0)
      },
      c(now) {
        return now
      }
    }

    const newrelic = window.newrelic
    if (newrelic) {
      if (newrelic.setCustomAttribute) {
        newrelic.setPageViewName(window.location.href.replace(/^[^/]*\/\//, ''))

        const roles = implicitFields.roles()
        if (roles) {
          newrelic.setCustomAttribute('roles', roles)
        }
        newrelic.setCustomAttribute('esi', implicitFields.esi())
        newrelic.setCustomAttribute('did', implicitFields.did())
        newrelic.setCustomAttribute('msid', implicitFields.msid())
        newrelic.setCustomAttribute('prefetch', window.afterEditorPrefetch)
        if (editorVersion) {
          newrelic.setCustomAttribute('editorVersion', editorVersion)
        }

                  // Running experiments:
        const runningExperiments = editorModel.runningExperiments
        if (runningExperiments) {
          const runningExperimentKeys = Object.keys(runningExperiments)
                          .filter(key =>
                             runningExperiments[key] !== 'old'
                          )
                          .map(experimentName => {
                            const experimentValue = runningExperiments[experimentName]
                            return experimentValue !== 'new' ? experimentName + '=' + experimentValue : experimentName
                          })
                          .join('][')
          if (runningExperimentKeys) {
            newrelic.setCustomAttribute('experiments', '[' + runningExperimentKeys + ']')
          }
        }
      }
      if (!suppressbi && editorVersion && newrelic.addPageAction) {
        newrelic.addPageAction('main-r loaded')
      }
    }

    return function () {
      let size = 0
      const now = Date.now()
      const payload = Object.keys(implicitFields)
                  .map(key => {
                    const result = key + '=' + implicitFields[key](now)
                    size += result.length
                    return result
                  })
      payload.size = size
      return payload
    }
  }())

  function sendBI(reportDef, params) {
    let payload = implicitParams()

    let size = payload.size
    params = Object.keys(params || {}).map(key => {
      let value = params[key]
      if (typeof value === 'string') {
        if (size + value.length > 1536) {
          value = value.substring(0, Math.max(1536 - size, 32))
        }
        value = encodeURIComponent(value)
      }
      const result = key + '=' + value
      size += result.length
      return result
    })
    payload = params.concat(payload)

    const endpoint = reportDef.endpoint || 'editor'
    const evid = reportDef.evid
    const src = reportDef.src || 38
    payload = payload.length ? '&' + payload.join('&') : ''

    const srcBI = base + '/' + endpoint + '?evid=' + evid + '&src=' + src + '&majorVer=3&viewMode=editor' + payload
    if (suppressbi) {
      window.console.log('BI:', srcBI)
    } else {
      (new window.Image()).src = srcBI
    }
  }

  const bi = {
    event(reportDef, params) {
      if (typeof reportDef === 'number') {
        reportDef = {
          evid: reportDef
        }
      }
      sendBI(reportDef, params)
    },
    error: (function () {
      const errorSeverityMap = {
        recoverable: 10,
        warning: 20,
        error: 30,
        fatal: 40
      }
      return function (reportDef, params) {
        params = params || {}
        const rd = {
          evid: 10,
          endpoint: reportDef.endpoint || 'trg'
        }
        const p = {
          errn: reportDef.errorName,
          errc: reportDef.errorCode,
          sev: errorSeverityMap[reportDef.severity] || reportDef.severity,
          cat: 1,
          iss: 1
        }
        const ut = getCookie('userType')
        if (ut) {
          p.ut = ut
        }
        Object.keys(params).forEach(param => {
          p[param] = params[param]
        })
        sendBI(rd, p)
      }
    }())
  }
  window.bi = bi

  if ((isDebug || suppressbi || !editorVersion) && !queryUtil.isParameterTrue('bi')) {
    return
  }

  let sendErrorOnce = function (errorName, errorCode, severity) { //eslint-disable-line func-style
    sendErrorOnce = function () {} // only report one error per session
    const params = Array.prototype.slice.call(arguments, 3).reduce((result, arg, index) => {
      result['p' + (index + 1)] = arg
      return result
    }, {})
    bi.error({
      errorName,
      errorCode,
      severity
    }, params)
  }

  const origOnError = window.onerror || function () {}
  window.onerror = function (errorMsg, url, line, column, err) {
    const where = err && typeof err.stack === 'string' ? err.stack : url
    sendErrorOnce('JAVASCRIPT_ERROR', 111022, 'fatal', errorMsg, where, line, column)
    return origOnError.apply(this, arguments)
  }

  if (window.console) {
    const origError = window.console.error
    if (origError) {
      window.console.error = function () {
        sendErrorOnce.bind(null, 'CONSOLE_ERROR', 111023, 'error').apply(null, arguments)
        return origError.apply(this, arguments)
      }
    }
  }

  const origRjsError = requirejs.onError || function () {}
  requirejs['onError'] = function (err) { // eslint-disable-line dot-notation
          // because ajv requires js-beautify synchronously even if does not use
    if (err.message && err.message.indexOf && err.message.indexOf('Module name "js-beautify" has not been loaded yet') === 0) {
      return
    }
    const modules = (err.requireModules || []).join(';')
    const where = typeof err.stack === 'string' ? err.stack : ''
    const errn = err.errn || 'REQUIREJS_ERROR'
    const errc = err.errc || 111024
    const severity = err.severity || 'fatal'
    sendErrorOnce(errn, errc, severity, err.message, modules, where)
    return origRjsError.apply(this, arguments) // eslint-disable-line consistent-return
  }
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/editor/instrument.js